import { ZoomIn, ZoomOut, RotateCw, Maximize } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SmartViewerControlsProps } from './types';
import { cn } from '@/lib/utils';

export function SmartViewerControls({
  onZoomIn,
  onZoomOut,
  onReset,
  onRotate,
  canZoomIn,
  canZoomOut,
}: SmartViewerControlsProps) {
  const buttonClass = cn(
    "h-10 w-10 rounded-full",
    "bg-background/90 backdrop-blur-md",
    "border border-border/50",
    "shadow-lg hover:shadow-xl",
    "hover:bg-primary/10 hover:border-primary/50",
    "transition-all duration-200",
    "text-foreground hover:text-primary"
  );

  return (
    <div className="fixed bottom-8 right-8 z-[60] flex flex-col gap-2">
      <Button
        variant="ghost"
        size="icon"
        className={buttonClass}
        onClick={onZoomIn}
        disabled={!canZoomIn}
        aria-label="Zoom avant"
      >
        <ZoomIn className="w-5 h-5" />
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        className={buttonClass}
        onClick={onZoomOut}
        disabled={!canZoomOut}
        aria-label="Zoom arrière"
      >
        <ZoomOut className="w-5 h-5" />
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        className={buttonClass}
        onClick={onReset}
        aria-label="Réinitialiser le zoom"
      >
        <Maximize className="w-5 h-5" />
      </Button>
      
      <Button
        variant="ghost"
        size="icon"
        className={buttonClass}
        onClick={onRotate}
        aria-label="Rotation 90°"
      >
        <RotateCw className="w-5 h-5" />
      </Button>
    </div>
  );
}
